module.exports = __webpack_public_path__ + "img/TX5FC.png";